define('notifications',["require", "exports", "./util/log"], function (require, exports, log) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.error = void 0;
    var delay = 5000;
    function error(msg) {
        log.error("notification: \"" + msg + "\"");
        var bar = document.createElement("div");
        bar.classList.add("notification-bar", "text-danger");
        bar.innerText = msg;
        document.body.appendChild(bar);
        setTimeout(function () {
            bar.classList.add("in");
        }, 1);
        // Hide after delay
        setTimeout(function () {
            bar.classList.remove("in");
            setTimeout(function () {
                document.body.removeChild(bar);
            }, 500);
        }, delay);
    }
    exports.error = error;
});
//# sourceMappingURL=/assets/javascripts/notifications.js.map;
